<template>
  <div class="GeneralCourse">
    <div class="SearchCourse">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 25%;
          height: 100%;
          border-right: 1px solid #c3c3c3;
          padding: 0 10px;
        "
      >
        <b-button
          class="BtnRegister"
          style="background: #0188c8"
          @click="handleModals('user')"
        >
          <b-icon-plus scale="1.5"></b-icon-plus>
          Novo Usuário</b-button
        >
      </div>
      <div class="searchInput">
        <b-form-select
          class="searchFilter"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
        ></b-form-select>
        <b-input
          size="sm"
          placeholder="Pesquisar"
          v-model="search"
          class="inputSearch"
          @keyup.enter="searchUser()"
        ></b-input>
        <b-button size="sm" @click="searchUser()" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
        <div class="searchInputAll" style="justify-content: flex-end">
          <button class="searchAll" @click="searchUser()">ver tudo</button>
        </div>
      </div>
      <div style="width: 10%">
        <img class="verified" :src="verified" />
      </div>
    </div>
    <div class="ContainerSearchInput">
      <div class="textRegister">
        <span>Usuários Registrados</span>
      </div>
      <div class="textRegister1">
        <button class="btnConfirmSearch" @click="toggleUserList">
          {{
            showExternalUsers
              ? "Exibir Usuários Internos"
              : "Exibir Usuários Externos"
          }}
        </button>
      </div>
    </div>
    <div style="display: flex">
      <div class="ContentTable" style="color: #3a4750; width: 100%">
        <div
          v-for="user in displayedUsers"
          :key="user.id"
          @click="findById(user)"
          class="rowCLient"
        >
          <span
            class="notResult"
            :style="`width: 50px; height: 50px; background-image: url(${notImg}); background-repeat: no-repeat; background-size: cover; background-position: center center`"
          />
          <div class="celTable" style="width: 40%; min-width: 40%">
            <span class="textEllipsis">
              <strong>Nome: </strong>
              <strong
                style="
                  color: #403b74;
                  font-weight: bold;
                  text-transform: uppercase;
                  padding-left: 3px;
                "
                >{{ user.name }}</strong
              >
            </span>
          </div>
          <div class="celTable" style="width: 20%">
            <span class="textEllipsis">
              <strong>CPF: </strong>
              {{ user.cpf || "000.000.000-00" }}</span
            >
          </div>
          <div class="celTable" style="width: 20%">
            <span class="textEllipsis"
              ><strong>Tipo: </strong>{{ user.type }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="spinGeneral" class="loadingLazy">
      <div class="loader"></div>
    </div>
    <div :class="sizeModalRegister">
      <div :class="modalContainer" v-if="colapseRegister">
        <b-button class="closeModalRegister" @click="modalHeight"> X </b-button>
        <User
          class="cardContentModal"
          @getAllCourse="handleGetAllCourses($event)"
        />
      </div>
    </div>
    <b-modal id="modal-excluir" hide-footer hide-header centered>
      <div>
        <div class="contentTitle">
          <h6 class="titleModalReversalOrDelete">Excluir</h6>
        </div>

        <section
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 20px;
            margin-top: 20px;
            margin-bottom: 15px;
            padding: 0 10px;
          "
        >
          <div style="width: 100%">
            <p class="subTitle" style="margin: 0">
              O item selecionado esta prestes a ser excluido!
            </p>
          </div>

          <div style="width: 100%">
            <b-form-checkbox
              class="footerTitle"
              size="sm"
              id="checkbox-1"
              v-model="confirmDelete"
              name="checkbox-1"
            >
              Estou ciente e desejo excluir.
            </b-form-checkbox>
          </div>
        </section>

        <div class="btnsModalActions">
          <button class="btnCancel">Não</button>
          <button class="btnConfirm" style="position: relative">
            Sim, excluir
            <span
              v-if="spinLoadingActionsButton"
              style="position: absolute; right: 5px"
              ><b-spinner small
            /></span>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import User from "../GeneralUser/User.vue";
import { mapMutations, mapState } from "vuex";
import verified from "../../assets/user.svg";
import notImg from "../../assets/notImg.png";
import CourseService from "../../services/course";
import { api } from "../../services/axios";

export default {
  props: {
    getAllUsers: {
      type: Boolean,
    },
  },
  components: {
    User,
  },
  data() {
    return {
      counter: {},
      notImg: notImg,
      verified: verified,
      supplierLenght: 0,
      alterCourse: null,
      search: "",
      type: "",
      startDate: "",
      endDate: "",
      Users: [],
      usersIntenral: [],
      usersExternal: [],
      showExternalUsers: false,
      displayedUsers: [],
      page: 1,
      filterCombobox: [
        { value: "name", text: "Nome" },
        { value: "", text: "Todos" },
      ],
      confirmDelete: false,
      spinLoadingActionsButton: false,
      spinGeneral: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_USER",
    ]),

    async fetchUsers() {
      try {
        this.spinGeneral = true;
        const internalUsers = await api.get("/users?type=internal");
        this.usersInternal = internalUsers.data.data;

        const externalUsers = await api.get("/users?type=external");
        this.usersExternal = externalUsers.data.data;

        this.displayedUsers = this.usersInternal;
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    toggleUserList() {
      this.showExternalUsers = !this.showExternalUsers;
      this.displayedUsers = this.showExternalUsers
        ? this.usersExternal
        : this.usersInternal;
    },

    openModalToReceive(Users) {
      this.SET_DATA_SEARCH_FROM_USER(Users);
      this.ALTER_TYPE_REGISTER("user");
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    async findById(user) {
      try {
        const result = await CourseService.usersById(user.id);
        this.openModalToReceive(result.data);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },

    async searchUser() {
      try {
        this.spinGeneral = true;
        const { data } = await api.get(`/users?${this.type}=${this.search}`);

        this.displayedUsers = data.data;
        this.type = "";
        this.search = "";
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    handleEventGetAllCourse(event) {
      this.alterCourse = event;
    },

    modalHeight() {
      this.SET_COLAPSE_REGISTER(!this.colapseRegister);
      this.colapseRegister
        ? this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral")
        : this.ALTER_SIZE_MODAL_REGISTER("disable");
      this.modalContainer
        ? this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer")
        : this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");

      if (!this.colapseRegister && this.sizeModalRegister === "disable") {
        this.SET_DATA_SEARCH_FROM_USER({});
      }
    },

    async handleModals(name) {
      this.ALTER_TYPE_REGISTER(name);
      this.modalHeight();
    },

    handleGetAllCourses(event) {
      this.alterCourse = event;
      this.modalHeight();
    },
    openDelete() {
      this.$bvModal.show("modal-excluir");
    },
  },
  computed: {
    ...mapState({
      sizeModalRegister: (state) => state.sizeModalRegister,
      typeRegister: (state) => state.typeRegister,
      colapseRegister: (state) => state.colapseRegister,
      modalContainer: (state) => state.modalContainer,
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
  },
  created() {
    this.fetchUsers();
    this.SET_COLAPSE_REGISTER(false);
    this.SET_DATA_SEARCH_FROM_USER({});
    this.ALTER_SIZE_MODAL_REGISTER("disable");
    this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");
  },
  mounted() {
    this.fetchUsers();
  },
  watch: {
    async getAllUsers() {
      await this.fetchUsers();
    },
    isSearchRegisters() {
      this.fetchUsers();
    },
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_USER({});
  },
};
</script>
<style scoped>
.GeneralCourse {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: auto;
  font-size: 13px;
}

.ContainerBtnRegister {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 30px;
  padding: 20px 0;
  border-bottom: 1px solid rgb(227, 227, 227);
}

.BtnRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.SearchCourse {
  margin-top: 70px;
  display: flex;
  width: 100%;
  height: 80px;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: 0px 10px 4px -10px rgba(142, 142, 142, 0.78);
  justify-content: space-between;
  align-items: center;
}

.ItemSumRegisters {
  width: 25%;
  height: 60px;
  border-radius: 5px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.ItemSumRegisters:hover {
  background: rgba(245, 245, 245, 0.546);
}
.ItemSumRegisters:focus {
  background: rgba(245, 245, 245, 0.764);
}

.verified {
  display: flex;
  width: 100%;
  height: 70px;
}

.searchInput {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 10px 20px;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.textRegister1 {
  padding: 5px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 400;
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.searchInputAll {
  width: 30%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 48px;
  left: 61px;
  height: calc(100% - 45px);
  max-height: calc(100% - 45px);
  overflow: auto;
  width: calc(100% - 55px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.cardContentModal {
  width: 85vw;
  margin-top: 20px;
  margin-left: 5vw;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #0188c8;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

.closeModalRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.contentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.subTitle {
  color: #767676;
  font-size: 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  margin: 0;
}

.titleModalReversalOrDelete {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitle {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActions {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirm {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnConfirmSearch {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 100%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancel {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

.closeModalRegister:hover {
  background: whitesmoke;
  color: red;
}

.closeModalRegister:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 4px;
  width: 100%;
  max-width: 100%;
}

.rowCLient {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 65px;
  gap: 20px;
  padding: 2px 10px;
  cursor: context-menu;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.131);
}

.rowCLient:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.celTableInfos {
  display: flex;
  gap: 20px;
  width: 20%;
  height: 50px;
  text-align: center;
  justify-content: flex-end;
  align-items: flex-end;
}

.countItem {
  width: 20px;
  border-radius: 5px;
  background-color: rgb(0, 81, 169);
  color: white;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  border-radius: 5px;
  height: 20px;
  background: rgb(238, 238, 238);
  font-size: 10px !important;
  font-weight: normal !important;
  padding: 10px;
  color: #001c29;
  margin: 0;
  height: 25px;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 20%;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.notResult {
  max-height: 50px;
  border-radius: 50%;
  max-width: 50px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 29px;
}

.trTable {
  text-align: center;
  height: 29px;
  cursor: context-menu;
  font-size: 12px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

tbody tr:hover {
  background: rgb(194, 193, 193);
  cursor: pointer;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.wtsTd {
  display: flex;
  gap: 2px;
  padding-top: 5px;
  cursor: pointer;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.titleCountRegisters {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .titleCountRegisters {
    font-size: 10px;
  }
  .ItemSumRegisters {
    gap: 0px;
    width: 45%;
    height: 45px;
    justify-content: space-between;
  }
  .GeneralCourse {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  .BtnRegister {
    width: 45%;
    font-size: 10px;
    height: 25px;
  }
  .ContainerBtnRegister {
    margin-top: 0px;
    padding-bottom: 20px;
  }
  .SearchCourse {
    height: 74px;
    margin-top: 50px;
  }
}

@media screen and (max-width: 700px) {
  .cardContentModal {
    width: 100vw;
    margin-top: 30px;
    margin-left: 0vw;
  }

  .GeneralCourse {
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 11px;
  }

  .SearchCourse {
    margin: 55px 0 10px 0;
    gap: 20px;
    padding: 0 0 10px 0;
    justify-content: center;
    align-items: center;
  }

  .ItemSumRegisters {
    width: 45%;
    height: 50px;
    gap: 0px;
    font-size: 10px;
    justify-content: center;
  }

  .ContainerBtnRegister {
    margin-top: 0px;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .BtnRegister {
    width: 45%;
    height: 40px;
    font-size: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .ModalGeneral {
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
</style>